export default __webpack_public_path__ + "static/anon_booking-b9859ce67168a173efcb377ed23feec1.png";